export default __webpack_public_path__ + "static/media/outcess7.21b079dd.jpeg";